<template>
    <div id="cashings_container">
        <!-- Delete cashing modal -->
        <delete-cashing-modal ref="deleteCashingModal"
            v-show="cashingToDelete"
            :cashing="cashingToDelete"
            @cashing-deleted="onCashingDeleted()">
        </delete-cashing-modal>
        
        <!-- Capture authorizations modal -->
        <capture-auth-modal ref="captureAuthModal"
            v-show="cashingWithAuthToCapture"
            :cashing="cashingWithAuthToCapture"
            @authorizations-captured="onAuthCaptured()">
        </capture-auth-modal>

        <!-- Cancel authorizations modal -->
        <cancel-auth-modal ref="cancelAuthModal"
            v-show="cashingWithAuthToCancel"
            :cashing="cashingWithAuthToCancel"
            @authorizations-canceled="onAuthCanceled()">
        </cancel-auth-modal>

        <div class="panel panel-default consumptions-list">
            <div class="panel-heading separator">
                <div class="panel-title">
                    <h4>Liste des encaissements</h4>
                    <slot name="filter"></slot>
                </div>
            </div>
            <div class="panel-body" >
                <div class="table-responsive" v-if="cashings && cashings.data && cashings.data.length > 0 && filters && readyToRender">
                    <pagination v-if="paginationNeeded"
                                :current-page="currentPage"
                                :total-pages="totalPages" @click="getPageOnClick">
                    </pagination>
                    <table class="table table-hover table-borderless table-striped table-condensed table-detailed" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Client</th>
                                <th>Type</th>
                                <th>Montant</th>
                                <th>Crée le</th>
                                <th>Statut</th>
                                <th class="text-center">Opérations</th>
                            </tr>
                        </thead>
                        <tbody >
                          <template v-for="(cashing, index) in this.uptodateCashings">
                              <item @click="onItemClick(index)"
                                    :cashing="cashing"
                                    :show-details="idxItemDetails === index"
                                    @make-cash-payment.capture="$emit('make-cash-payment', $event)"
                                    @delete-cashing="initDeleteCashingModal($event)"
                                    @cancel-authorizations="initCancelAuthModal($event)"
                                    @capture-authorizations="initCaptureAuthModal($event)"
                                    :key="'cashing-item-'+index">
                              </item>
                              <item-detail v-if="idxItemDetails === index"
                                            :cashing="cashing"
                                            :key="'cashing-item-details-'+index">
                              </item-detail>
                          </template>
                        </tbody>
                    </table>
                    <pagination v-if="paginationNeeded"
                                :current-page="currentPage"
                                :total-pages="totalPages" @click="getPageOnClick"></pagination>
                </div>
                <div v-else>
                    <h5 class="light">Aucun enregistrement correspondant</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .panel .panel-heading .panel-title { width: 100%; }
</style>

<script>
import DeleteCashingModal from './DeleteCashingModal'
import CaptureAuthModal from './CaptureAuthModal'
import CancelAuthModal from './CancelAuthModal'
import Pagination from "components/Pagination"
import Item from './Item'
import ItemDetail from './ItemDetail'
import {mapState, mapActions} from 'vuex'

export default {
        name:"CashTable",

        data () {
            return {
                idxItemDetails: null,
                cashingToDelete: null,
                cashingWithAuthToCapture: null,
                cashingWithAuthToCancel: null
            }
        },

        components: {
            DeleteCashingModal,
            CaptureAuthModal,
            CancelAuthModal,
            Pagination,
            Item,
            ItemDetail
        },

        computed: {
            ...mapState('cash', [
                'cashings',
                'cashing_created_and_waiting_for_payment',
                'filters'
            ]),
            readyToRender() {
                return this.filters != null && this.cashings != null
            },

            uptodateCashings(){
                return this.cashings.data
            },

            paginationNeeded () {
                return this.cashings.last_page > 1
            },

            totalPages() {
                return this.cashings.last_page
            },

            currentPage(){
                return this.cashings.current_page - 1
            }
        },

        methods: {
            ...mapActions('cash', ['customerCashings']),

            onItemClick (idx) {
                this.idxItemDetails = (this.idxItemDetails !== idx) ? idx : null
            },

            getPageOnClick(event){
                if (event + 1 <= this.totalPages)
                {
                    var params = this.filters
                    _.assign(params, {page:event + 1})
                    this.customerCashings(params)
                }
            },

            initDeleteCashingModal(event) {
                this.cashingToDelete = event

                this.$refs.deleteCashingModal.showModal()
            },

            initCaptureAuthModal(event) {
                this.cashingWithAuthToCapture = event

                this.$refs.captureAuthModal.showModal()
            },
            
            initCancelAuthModal(event) {
                this.cashingWithAuthToCancel = event

                this.$refs.cancelAuthModal.showModal()
            },

            onCashingDeleted() {
                this.customerCashings().then(() => {
                    this.cashingToDelete = null

                    this.$refs.deleteCashingModal.hideModal()
                })
            },
            
            onAuthCaptured() {
                this.customerCashings().then(() => {
                    this.cashingWithAuthToCapture = null

                    this.$refs.captureAuthModal.hideModal()
                })
            },

            onAuthCanceled() {
                this.customerCashings().then(() => {
                    this.cashingWithAuthToCancel = null

                    this.$refs.cancelAuthModal.hideModal()
                })
            }
        },

        watch : {
            cashing_created_and_waiting_for_payment : function (newv, oldv) {
                if (newv != null)
                this.$emit('make-cash-payment', newv)
                this.customerCashings()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Cash/CashTable.vue